import InlineAlert from "@storeblocks/inline-alert";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import { getFMSProductName } from "Store/texts/helpers/FMSproductName";
import { useProductTexts } from "Store/texts/hooks";
import { isChildCloseToMaxAge } from "Utils/ageUtils";
import { isDefined, isEmpty } from "Utils/functions";
import { replacePlaceholder } from "Utils/replacePlaceholder";
import { parse } from "date-fns";
import { useFormikContext } from "formik";
import React from "react";
import { CHILD_END_AGE, CHILD_MAX_AGE } from "../childConstants";
import { ChildProductDetailsFormValues } from "./childProductDetailsInterfaces";

export const CloseToMaxAgeWarning = (): React.ReactElement | null => {
  const formProps = useFormikContext<ChildProductDetailsFormValues>();
  const [
    {
      formText: { aboutChild },
    },
    lang,
  ] = useProductTexts(getFMSProductName(INSURANCE_NAME_VALUE.CHILD));

  if (
    !isEmpty(formProps.errors.childBirthDate) ||
    !isDefined(formProps.values.childBirthDate) ||
    !isChildCloseToMaxAge(
      parse(formProps.values.childBirthDate, "dd.MM.yyyy", new Date()),
      CHILD_MAX_AGE,
    )
  ) {
    return null;
  }

  return (
    <InlineAlert
      title={replacePlaceholder(
        aboutChild.birthDate.warning.closeToMaxAge[lang],
        { maxAge: String(CHILD_MAX_AGE), endAge: String(CHILD_END_AGE) },
      )}
    />
  );
};
